import htmlComponent from 'htmlcomponent';
import {storeScrollPos, restoreScrollPos} from '@/utils/scrollpos';

export const OverlayMixin = {
  props: {
    overlayType: {
			type: String,
			default() {
				return '';
			},
		},
		htmlClasses: {
			type: Array,
			default: () => [],
		},
  },
  data() {
		return {
			overlayIgnoreScrollPos: false,
			overlaysAllowed: [],
			defaultHtmlClasses: [
				'show--overlay',
			],
		};
  },
  computed: {
		overlayShowClass() {
			return `show--${this.overlayType}`;
		},
		customHtmlClasses() {
			return [...this.defaultHtmlClasses, ...this.htmlClasses].reduce((acc, cls) => {
				return {...acc, [cls]: this.visible};
			}, {});
		}
	},
  mounted() {
		this.html = document.documentElement;

		htmlComponent.listen('overlay:open', this.openOverlayHandler.bind(this));
		htmlComponent.listen('overlay:close', this.closeOverlayHandler.bind(this));
		htmlComponent.listen('overlay:toggle', this.toggleOverlayHandler.bind(this));
	},
  methods: {
		openOverlay(data) {
			htmlComponent.send('overlay:open', {...data, type: this.overlayType});
		},
		closeOverlay(data) {
			htmlComponent.send('overlay:close', {...data, type: this.overlayType});
		},
		toggleOverlay(data) {
			htmlComponent.send('overlay:toggle', {...data, type: this.overlayType});
		},
		async openOverlayHandler(e, data) {
			if (data.type !== this.overlayType && this.overlaysAllowed.indexOf(data.type) < 0) {
				this.html.classList.remove(this.overlayShowClass);
			}
			else {
				try {
					await this.beforeOverlayOpen(data);
					if (!this.overlayIgnoreScrollPos) {
						storeScrollPos();
					}
					this.html.classList.add(this.overlayShowClass);
					this.afterOverlayOpen(data);
				}
				catch(err) {
					// do nothing
				}
			}
		},
		async closeOverlayHandler(e, data) {
			if (data.type === this.overlayType) {
				try {
					await this.beforeOverlayClose(data);
					this.html.classList.remove(this.overlayShowClass);

					if (!this.overlayIgnoreScrollPos) {
						restoreScrollPos();
					}
					this.afterOverlayClose(data);
				}
				catch(err) {
					// do nothing
				}
			}
		},
		toggleOverlayHandler(e, data) {
			if (data.type === this.overlayType) {
				if (this.html.classList.contains(this.overlayShowClass)) {
					htmlComponent.send('overlay:close', data);
				}
				else {
					htmlComponent.send('overlay:open', data);
				}
			}
		},
		beforeOverlayOpen(data) {},
		beforeOverlayClose(data) {},
		afterOverlayOpen(data) {
			// do something
		},
		afterOverlayClose(data) {
			// do something
		},
  }
};

export default OverlayMixin;
